import React, { useEffect,useState } from 'react';
import {useTranslation } from 'react-i18next';

function AutoTextChanger() {
    const values = ['Clients', 'Experts', 'ESN'];
    const [text, setText] = useState('');
    const [index, setIndex] = useState(0);
    const [intervalId, setIntervalId] = useState(null);
    const { i18n } = useTranslation();
    useEffect(() => {
        const value = values[index];
        let currentIndex = 0;
        setText('');

        setIntervalId(setInterval(() => {
            if (currentIndex < value.length) {
                const newText = value.substring(0, currentIndex + 1);
                setText(newText);
                currentIndex++;
            } else {
                clearInterval(intervalId);
                setTimeout(() => {
                    setIndex((index + 1) % values.length);
                }, 1000);
            }
        }, 200));

        return () => clearInterval(intervalId);
    }, [index]);

    return (
        <div>
            <p>{i18n.t(text)}</p>
        </div>
    );
}

export default AutoTextChanger;